<script lang="ts">
	import { page } from "$app/stores";
	const currentPath = $page.url.pathname;
</script>

<div class="bg-[#fffcd3] py-4">
	<form action="/users/verify_email" method="get">
		<input type="hidden" name="redirect" value={currentPath} />
		<button class="container-1200 flex flex-wrap items-center justify-between">
			<div class="flex flex-wrap items-center text-red-600">
				<div class="text-23 material-icons mr-1 text-orange-600">info</div>
				<span class="mr-1 items-center align-middle font-bold"> Email Verification required:</span>
				to send newsletters, we require email verification.
			</div>
			<div class="hidden font-bold text-nxgray-600 lg:inline-block">Verify your email</div>
		</button>
	</form>
</div>
